import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { ShDroppanelSelectComponent } from '../../../../elements/components/droppanel-select/droppanel-select.component';
import { ShIconComponent } from '../../../../elements/components/icon/icon.component';
import { ShClickOutsideDirective } from '../../../../elements/directives/click-outside/click-outside.directive';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormMultiSelectComplexBaseComponent } from '../base-complex/form-multi-select-complex-base.component';

@Component({
    selector: 'sh-form-multi-select-base',
    templateUrl: '../base-complex/form-multi-select-complex-base.component.html',
    styleUrls: ['../base-complex/form-multi-select-complex-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormMultiSelectBaseComponent)],
    standalone: true,
    imports: [ShClickOutsideDirective, ShDroppanelSelectComponent, ShIconComponent, AsyncPipe]
})
export class ShFormMultiSelectBaseComponent<T = string> extends ShFormMultiSelectComplexBaseComponent<T> {
    @Input() unwrapList: boolean = false;

    constructor(
        changeDetectorRef: ChangeDetectorRef,
        protected injector: Injector
    ) {
        super(changeDetectorRef, injector);
    }

    propagateChange(formValues: FormValue<T>[]): void {
        const unwrapped: any = formValues
            .filter(fv => fv.state === FormValueState.SET)
            .map(FormValue.unwrap.bind(this));
        if (!this.multiple && this.unwrapList) {
            return super.propagateChange(unwrapped?.length ? unwrapped[0] : undefined);
        }
        super.propagateChange(unwrapped);
    }

    writeValue(obj: any[]): void {
        let base: any[];
        if (!this.multiple && this.unwrapList && !!obj) {
            base = [obj];
        } else {
            base = obj;
        }

        base = base instanceof Array ? base : [];
        super.writeValue(base.map(el => FormValue.wrap(el)));
    }
}
